import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { CustomImage, Text } from '@src/components';
import { Button } from 'antd';
import { setActiveStep } from '@src/store/slice/addNewCarStore/addCarTypeSlice';
import iconSuccess from '@src/assets/icons/icon-success.svg';
import iconWarning from '@src/assets/icons/icon-warning-orange.svg';
import iconDateRed from '@src/assets/icons/icon-datepicker-red.svg';
import iconInfo from '@src/assets/icons/icon-info.svg';
import '@src/styles/autoUploadInstruction/completed.scss';
import '@src/styles/cardOrder/cardCompleted.scss';
import { getVehicleForThanksPage } from '@src/store/slice/addNewCarStore/addCarPlateDetailSlice';

const ItemCardImage = ({ item }) => {
  const Icon = useMemo(() => {
    if (item?.isCalendar) {
      return iconDateRed;
    } else if (item?.isInfo) {
      return iconInfo;
    } else {
      return iconWarning;
    }
  }, [item]);
  return (
    <div className="item-card-image">
      <CustomImage src={Icon} />
    </div>
  );
};

const AddNewCarApproval = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { isAdmin } = useSelector((state) => state.auth);
  const { allPlatesDetailItems } = useSelector((state) => state.addCarPlateDetail);
  const [thanksPageCardOrderTextList, setThanksPageCardOrderTextList] = useState(null);

  const redirectToHomePage = () => {
    history.push(
      isAdmin
        ? {
            pathname: '/admin/ticket-car/management-car-processes',
            state: { newActiveKey: '1' },
          }
        : '/dashboard',
    );
    dispatch(setActiveStep(0));
  };

  useEffect(() => {
    getThanksPage();
  }, []);

  const getThanksPage = async () => {
    try {
      const vouId = allPlatesDetailItems[0]?.selectCustomerVousList?.vouId ?? 4;
      const deviceTypeId = allPlatesDetailItems[0]?.selectVehicleDeviceTypeList?.deviceTypeId;
      const response = await dispatch(getVehicleForThanksPage({ vouId, deviceTypeId })).unwrap();
      setThanksPageCardOrderTextList(response);
    } catch (error) {
      console.error('Error getThanksPage:', error);
    }
  };
  return (
    <div className="card-order-completed-content">
      <div className="success-order-header-content">
        <CustomImage src={iconSuccess} />
        <h1>{thanksPageCardOrderTextList?.title}</h1>
        {thanksPageCardOrderTextList?.shortMessage && (
          <h5>
            <div
              className="message"
              dangerouslySetInnerHTML={{ __html: thanksPageCardOrderTextList?.shortMessage }}
            />
          </h5>
        )}

        {thanksPageCardOrderTextList?.longMessage && (
          <p
            className={'description-list-long-text description-list-long-text-center'}
            dangerouslySetInnerHTML={{ __html: thanksPageCardOrderTextList?.longMessage }}
          />
        )}

        <div className="description-list">
          {thanksPageCardOrderTextList?.messageList &&
            thanksPageCardOrderTextList?.messageList.map((item, index) => {
              return (
                <p key={item.message}>
                  <ItemCardImage item={item} />
                  <div
                    className="message-list-item"
                    dangerouslySetInnerHTML={{ __html: item.message }}
                  />
                </p>
              );
            })}
        </div>
      </div>
      <div className="footer-content">
        <Button
          id="redirect"
          data-testid="redirect"
          onClick={redirectToHomePage}
          className="btn-blue"
        >
          <span>
            <Text t="returnToHomePage" />
          </span>
        </Button>
      </div>
    </div>
  );
};

export default AddNewCarApproval;
